// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import LeftNav from "@ces/XDL/Icons/LeftNav";
import RightNav from "@ces/XDL/Icons/RightNav";
import { fontConfig } from "@ces/XDL/PreStyle/typography";
import { xBaseTheme } from "@ces/XDL/types";
import { color } from "@ces/XDL/Utilities";
import { mergeWithCss } from "@ces/XDL/Utilities/mergeWithCss";
import { IconWrapper } from "@insite/mobius/Icon";
import { PaginationPresentationProps } from "@insite/mobius/Pagination";
import PaginationPresentationPropsDefault from "@insite/mobius/Pagination/presentationProps";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...PaginationPresentationPropsDefault,
        selectProps: {
            mergeCss: true,
            sizeVariant: "small",
            cssOverrides: {
                formField: css`
                    width: fit-content;
                    padding-right: 0;
                    gap: 12px;
                    align-items: baseline;
                `,
                formInputWrapper: css`
                    max-width: 75px;
                    width: unset;
                `,
            },
            labelProps: {
                size: 14,
                weight: fontConfig.weight.regular,
                css: css`
                    letter-spacing: 0;
                    line-height: 21px;
                    padding: 0;
                `,
            },
        },
        navIconsSrc: {
            firstPage: "ChevronsLeft",
            previousPage: LeftNav,
            nextPage: RightNav,
            lastPage: "ChevronsRight",
        },

        buttonProps: {
            mergeCss: true,
            sizeVariant: "small",
            typographyProps: {
                size: 12,
                lineHeight: "13px",
            },
            css: css`
                min-height: 26px;
                border: none;
                background: none;
                ${IconWrapper} {
                    color: ${color("text.link")};
                    &,
                    & svg {
                        width: 10px;
                        height: 18px;
                    }
                }
                &:disabled {
                    background: none;
                    ${IconWrapper} {
                        color: ${color("text.link", 0.33)};
                    }
                }
                &:hover:not(:disabled) {
                    background: ${color("common.ui1")};
                    border: none;
                    ${IconWrapper} {
                        color: ${color("common.ui8")};
                    }
                }
                &&&:focus {
                    background: none;
                }
            `,
        },
        cssOverrides: {
            ...mergeWithCss(PaginationPresentationPropsDefault?.cssOverrides, {
                ellipsis: css`
                    margin: 0 10px;
                `,
                linkList: css`
                    & > ul {
                        display: flex;
                        align-items: center;
                    }
                `,
            } as PaginationPresentationProps["cssOverrides"]),
        },
    },
} as xBaseTheme["pagination"];
